import {ContactsPanel} from './Contacts/Contacts';
import {observer} from 'mobx-react-lite';

const Agent = observer(() => {
    return <ContactsPanel selectContact={null}></ContactsPanel>;
});

export default Agent;
